import { ResetPasswordService } from 'application/services/reset-password'
import { apiLogin } from 'infra/adapters/http-client-adapter'

export const handleResetPassword = new ResetPasswordService(apiLogin)
